import { handleActions } from 'redux-actions';
import { initialState } from './constants';
import { fetchEducationalQualifications, setEducationalQualification } from './action';
import { isServer } from 'utils';

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [setEducationalQualification]: {
    next: (state: State.ExemptionEducational, action: any): State.ExemptionEducational => ({
      ...state,
      exempReference: action.payload.id,
      exemptReferenceFetched: true,
      exemptReferenceFrontloadRequest: isServer,
    }),
  },
  [fetchEducationalQualifications]: {
    next: (state: State.ExemptionEducational, action: any): State.ExemptionEducational => ({
      ...state,
      allEducationalReference: action.payload.getExemption,
    }),
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export default handleActions(ACTION_HANDLERS, initialState);
